import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  location: {
    latitude: number
    longitude: number
  }
}
interface Action {
  setLocation: (location: State['location']) => void
  reset: () => void
}

const baseStoreGeo = create<State & Action>((set) => ({
  location: { latitude: 0, longitude: 0 },
  setLocation: (location) => set(() => ({ location })),
  reset: () => set({ location: { latitude: 0, longitude: 0 } })
}))

const useStoreGeo = createSelectors(baseStoreGeo)

export default useStoreGeo
